<section
	class="flex flex-col rounded-2xl bg-gray-000 p-3 transition-[padding,padding-block] duration-300 ease-out data-[collapsed=true]:py-1.5"
	aria-labelledby="wallet-balance-total-title"
	[attr.data-collapsed]="collapsed()">
	<div class="flex flex-col items-center gap-1 py-4">
		<p class="flex items-center gap-0.5 text-lg text-gray-800">
			@if (amountsHidden()) {
				<span class="font-black tracking-widest" data-cy="wallet-balance-status-total">{{ maskedValue }}</span>
			} @else {
				<ui-number
					format="1.0-0"
					dir="ltr"
					class="font-black tabular-nums"
					data-cy="wallet-balance-status-total"
					[value]="totalBalance()" />
			}
			<span>ریالءء</span>
		</p>
		<h2 id="wallet-balance-total-title" class="text-sm font-medium text-gray-900">موجودی کل بورس‌کالا</h2>
	</div>

	<!-- Rows 1fr → 0fr animates the breakdown's own height, whatever it measures. -->
	<div
		#breakdown
		class="grid transition-[grid-template-rows,opacity] duration-300 ease-out"
		data-cy="wallet-balance-breakdown"
		[style.grid-template-rows]="collapsed() ? '0fr' : '1fr'"
		[class.opacity-0]="collapsed()"
		[attr.aria-hidden]="collapsed()"
		[inert]="collapsed()">
		<div class="min-h-0 overflow-hidden">
			<div class="flex flex-col overflow-hidden rounded-xl border border-stroke-050">
				<!-- DOM order is the handoff's wallet order; in RTL the first slice sits on the
					right, beside the legend's first row. `flex-basis: 0` makes each slice's width
					its balance's share of what is left after every slice's minimum. -->
				<div
					class="flex gap-1 px-3 pt-3"
					role="img"
					aria-label="سهم هر کیف از موجودی کل"
					data-cy="wallet-balance-bar">
					@for (segment of segments(); track segment.key) {
						<div
							[class]="'h-2 min-w-1 basis-0 rounded-xs ' + segment.colorClass"
							[style.flex-grow]="segment.balance"
							[attr.data-cy]="'wallet-balance-segment-' + segment.key"></div>
					}
				</div>

				<!-- Label first, figure second: the RTL reading order, which puts the swatch and
					the name on the visual right and the figure on the left. -->
				<dl class="flex flex-col gap-2 p-3 text-xs text-gray-900">
					@for (row of primaryRows(); track row.key) {
						<div
							class="flex items-center justify-between gap-3"
							[attr.data-cy]="'wallet-balance-row-' + row.key">
							<dt class="flex items-center gap-1.5 font-medium">
								<span aria-hidden="true" [class]="'size-2 rounded-xs ' + row.colorClass"></span>
								{{ row.label }}
							</dt>
							<dd class="flex items-center gap-1">
								@if (amountsHidden()) {
									<span class="tracking-widest" [attr.data-cy]="'wallet-balance-value-' + row.key">{{
										maskedValue
									}}</span>
								} @else {
									<ui-number
										format="1.0-0"
										dir="ltr"
										class="tabular-nums"
										[attr.data-cy]="'wallet-balance-value-' + row.key"
										[value]="row.balance" />
								}
								<span>ریالءء</span>
							</dd>
						</div>
					}

					<!-- انبار, اختیار معامله and آتی کالا are listed in the «سایر کیف‌پول‌ها» sheet,
						which this row opens. -->
					<div class="flex items-center justify-between gap-3">
						<dt class="flex items-center gap-1.5 font-medium">
							<span aria-hidden="true" [class]="'size-2 rounded-xs ' + othersColor"></span>
							سایر
						</dt>
						<dd class="flex">
							<ui-button
								variant="mute"
								model="outline"
								size="sm"
								iconOnly
								label="مشاهده سایر کیف‌پول‌ها"
								aria-haspopup="dialog"
								extraButtonClasses="size-6 rounded-md border-stroke-050 bg-transparent"
								data-cy="wallet-balance-others-toggle"
								(clicked)="otherWalletsRequested.emit()">
								<ui-icon width="20" height="16" iconName="chevron-down" aria-hidden="true" />
							</ui-button>
						</dd>
					</div>
				</dl>
			</div>
		</div>
	</div>
</section>
